import React, { useEffect, useState, useContext } from 'react';
import { StyleSheet, Text, View, KeyboardAvoidingView, TextInput, ScrollView, TouchableOpacity, Alert, ActivityIndicator, Platform } from 'react-native';

import { StatusBar } from 'expo-status-bar';

import axios from 'axios';

import { CredentialsContext } from '../components/CredentialsContext';
import StyledText from '../components/StyledText';
import AsyncStorage from '@react-native-async-storage/async-storage';

import { EnglishStrings } from '../strings/English';
import { PersianStrings } from '../strings/Persian';
import { ArabicStrings } from '../strings/Arabic';

import envVars from '../env';

const ActivationWithSMS = props => {
    const [isHandlingSMSActivation, setIsHandlingSMSActivation] = useState(false)
    const [isHandlingActivation, setIsHandlingActivation] = useState(false)

    const [phoneNumberInputIsFocused, setPhoneNumberInputIsFocused] = useState(false)
    const [activationCode, setActivationCode] = useState('')

    const {storedCredentials, setStoredCredentials} = useContext(CredentialsContext);

    const strings = () => {
      if(props.route.params.language == 'English') {
          return EnglishStrings
      } else if(props.route.params.language  == 'Arabic') {
          return ArabicStrings
      } else return PersianStrings
    }

    const fetchActivationCode = () => {
        setIsHandlingSMSActivation(true)
        const url = envVars.SERVER_URL + envVars.SERVER_PORT + '/generateActivetionCode';

        const credentials = {
            userPhoneNumber : props.route.params.enteredPhoneNumber
        };

        axios.post(url, credentials)
        .then((res) => {
            const result = res.data;
            const {message, status, data} = result;

            if(status == 'SUCCESS'){
                const url = envVars.SERVER_URL + envVars.SERVER_PORT + '/sendActivationCode';

                axios.post(url, credentials)
                .then((res) => {
                    const result = res.data;
                    const {data} = result;

                    if(data.status == 200) setIsHandlingSMSActivation(false) 

                })
            }
        })

    }
    
    useEffect(() => {
      props.navigation.setOptions({
        headerStyle:{
          backgroundColor: 'transparent'
        },
        headerTransparent: true,
        headerTitle: '',
        headerLeftContainerStyle:{
          paddingLeft: 20
        },
        headerTintColor: 'white'
      })
      
      fetchActivationCode()
    },[])

    const persistantLogin = (credentials, message, status) =>{
      const updatedStoredCredentials = {...storedCredentials, ...credentials}

      AsyncStorage.setItem('flowerCribCredentials', JSON.stringify(updatedStoredCredentials))
      .then(()=> {
          setStoredCredentials(updatedStoredCredentials)
      })
      .catch(err =>{
          console.log(err);
      })        
      
     
        // AsyncStorage.setItem('flowerCribCredentials', JSON.stringify(credentials))
        // .then(()=> {  
        //     setStoredCredentials(credentials)
        // })
        // .catch(err =>{
        //     console.log(err);
        // })
    };

    const handleActivation = (code) => {
        setIsHandlingActivation(true);

        const url = envVars.SERVER_URL + envVars.SERVER_PORT + '/verifyWithSMS';
        const credentials = {
            userPhoneNumber : props.route.params.enteredPhoneNumber,
            userCode : activationCode 
        };

        axios.post(url, credentials)
        .then(res => {
            const result = res.data
            const {message, status, data} = result;

            if(status == 'SUCCESS') persistantLogin({...data}, message, status);
            else {
              if(Platform.OS == 'web') {
                const res = window.alert(strings().wrongCode)
              } else {
                Alert.alert(strings().error,strings().wrongCode,[
                  {
                    text: strings().ok
                  }
                ])
              }
            }
        })
    }

    return (
        <KeyboardAvoidingView style={{flex: 1}}>
          <ScrollView contentContainerStyle={{flexGrow:1}}>
          <View style={Styles.wrapper}>
    
          <StatusBar />
            <View style={Styles.contentWrapper}>
              <View style={Styles.headerCard}>
                <StyledText style={Styles.cardHeaderText}> {strings().textMessage} </StyledText>
                <StyledText style={Styles.cardHeaderTextDescription}> {strings().activationWithTextMessage} </StyledText>
              </View>
    
                {isHandlingSMSActivation ? 
                    <ActivityIndicator size='large'/>
                :
                    <View style={Styles.textInputWrapper} >
                            <View style={Styles.InputArea} >
                                <StyledText style={Styles.inputLabel}> {strings().activationCode} </StyledText>
                                <TextInput 
                                    style={{...Styles.textInput, ...{borderColor: phoneNumberInputIsFocused ? 'blue' : 'white', borderWidth:1}}}
                                    keyboardType= 'numeric'
                                    onFocus={()=> setPhoneNumberInputIsFocused(true) }
                                    onBlur={()=> setPhoneNumberInputIsFocused(false) }
                                    onChangeText={value => setActivationCode(value)} />
                            </View>
                            <StyledText style={{...Styles.cardHeaderTextDescription, ...{color: 'white'}}}> {strings().activationCodeSuccessfullySentTo} {props.route.params.enteredPhoneNumber} </StyledText>

                    </View>

                }
            </View>
            
            {isHandlingSMSActivation ? <View></View>
            :
            <View style={Styles.footer}>
                <TouchableOpacity style={Styles.submitBtn} 
                    onPress={()=> {isHandlingSMSActivation ? {} : handleActivation(activationCode)}} 
                >
                    <StyledText style={Styles.submitBtnText}> {strings().signIn} </StyledText>
                </TouchableOpacity> 
    
            </View>
            }
          </View>
          </ScrollView>
        </KeyboardAvoidingView>
      );
};

let Styles = {  
    wrapper:{
      flex: 1,
      justifyContent: 'space-between',
      backgroundColor: '#F26B08',
    },
    contentWrapper:{
  
    },
    headerCard:{
      width:'100%',
      minHeight: 250,
      height:'20%',
      padding: 15,
      alignSelf:'center',
      backgroundColor:'white',
      shadowColor: 'black',
      shadowOffset: {width:0 , height:2},
      shadowRadius: 6,
      shadowOpacity: 0.26,
      elevation:20,
      borderBottomEndRadius: 60 ,
      borderBottomStartRadius: 60,
      padding: 20,
      height: '30%',
      backgroundColor: '#1C0947',
      justifyContent: 'flex-end'
    },
    cardHeaderText:{
      fontWeight:'500',
      fontSize:35,
      color: 'white',
      // alignSelf: 'flex-end',
    },
    cardHeaderTextDescription:{
      fontSize:20,
      fontWeight:'200',
      color:'white',
      paddingVertical: 10,
      margin:5
    },
    textInputWrapper:{
      margin: '5%',
      marginTop: '10%',
    },
    textInput:{
      backgroundColor: 'white',
      padding: 15,
      marginTop: 10,
      marginBottom: 20,
      borderRadius: 40,
      shadowColor: 'black',
      shadowOffset: {width:0 , height:2},
      shadowRadius: 6,
      shadowOpacity: 0.26,
      elevation:20,
      fontSize: 25,
    },
    inputLabel:{
      fontSize: 20,
      fontWeight: '500',
      color: 'white'
    },
    InputArea:{
      width: '100%',  
    },
    footer:{
      paddingVertical:10,
      marginBottom: 10,
    },
    submitBtn:{
      backgroundColor: '#1C0947',
      alignItems: 'center',
      marginHorizontal:'5%',
      borderRadius: 40,
      minHeight: 60,
      justifyContent: 'center'
    },
    submitBtnText:{
      fontSize: 35,
      fontWeight: '300',
      color:'white',
      padding:5
    },
    alreadySinedUpTextArea:{
      alignItems:'center',
      marginTop: '5%'
    },
    alreadySinedUpText:{
      color: '#6F8FEA'
    }
};
// const Styles = StyleSheet.create({
//     wrapper:{
//         justifyContent:'center',
//         alignItems: 'center'
//     },

// });
export default ActivationWithSMS;